import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// import ChainedBackend from 'i18next-chained-backend';
// import LocalStorageBackend from 'i18next-localstorage-backend';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { translations } from '../config/translations';
import Config from '../config/config';
const languages = ['en', 'es', 'de', 'fr', 'ja', 'zh', 'pt'];
const detectionOrder = ['querystring', 'navigator'];
// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next
    .use(initReactI18next)
    .use(Backend)
    .use(LanguageDetector)
    .init({
    resources: translations,
    fallbackLng: 'en',
    supportedLngs: languages,
    nonExplicitSupportedLngs: true,
    cleanCode: true,
    detection: {
        order: detectionOrder
    },
    interpolation: {
        escapeValue: false // recommended by their quick start guide, since react already escapes values for us
    },
    debug: Config.isRunningLocally
});
export default i18next;
